import { ReviewsModalType } from '@/types/modal';
import useReviews, { REVIEWS_PAGE_LIMIT, REVIEWS_MODAL_LIMIT } from '@/hooks/useReviews';
import Card from '@/components/elements/Card/Card';

import { Reviews } from '@/features/reviews/Reviews';
import useMobileView from '@/hooks/useMobileView';

type ReviewsProps = {
  placeId: number;
  isMpReviews?: boolean;
  reviewsUid?: string;
};

export function PlacePageReviews(props: ReviewsProps) {
  const { placeId, isMpReviews, reviewsUid } = props;
  const { isMobileView } = useMobileView();

  const { searchFilter, openReviewsModal } = useReviews({
    uid: reviewsUid,
    initiateState: false,
    originType: 'placePage',
  });

  const setReviewModal = (data: ReviewsModalType) => {
    openReviewsModal(data);
  };

  if (!searchFilter) {
    return null;
  }

  const commonModalProps = {
    placeId,
    timeFilter: searchFilter.timeFilter,
    show: true,
    isMpReviews,
    context: 'placePage' as const,
  };

  return (
    <Card size={isMobileView ? 'lg' : 'xl'}>
      <Reviews
        uid={reviewsUid}
        placeId={placeId}
        onEmployeeClick={(employeeId: number, serviceId: number) => {
          setReviewModal({
            ...commonModalProps,
            focus: 'employee',
            employeeId,
            limit: REVIEWS_PAGE_LIMIT,
            serviceId: undefined,
          });
        }}
        onServiceClick={(employeeId: number, serviceId: number) => {
          setReviewModal({
            ...commonModalProps,
            focus: 'service',
            employeeId: undefined,
            limit: REVIEWS_PAGE_LIMIT,
            serviceId,
          });
        }}
        onScoreTitleClick={() => {
          setReviewModal({
            ...commonModalProps,
            serviceId: undefined,
            employeeId: undefined,
            limit: REVIEWS_PAGE_LIMIT,
            focus: 'rating',
          });
        }}
        onRatingClick={(rating: string) => {
          setReviewModal({
            ...commonModalProps,
            serviceId: undefined,
            employeeId: undefined,
            limit: REVIEWS_PAGE_LIMIT,
            focus: 'rating',
            rating,
          });
        }}
        onShowMoreClick={() => {
          setReviewModal({
            ...commonModalProps,
            serviceId: undefined,
            employeeId: undefined,
            limit: REVIEWS_MODAL_LIMIT,
            focus: 'rating',
          });
        }}
        focus={'rating'}
      />
    </Card>
  );
}

export default PlacePageReviews;
